import React from 'react';
import { StoreModule } from './StoreModule';
var SetupStore = /** @class */ (function () {
    function SetupStore(path, initialState) {
        this.storeModule = new StoreModule(path, initialState);
    }
    SetupStore.prototype.getInitialState = function () {
        return this.storeModule.initialState;
    };
    SetupStore.prototype.setSimpleAction = function (type, tinyReducer) {
        return this.storeModule.setSimpleAction(type, tinyReducer);
    };
    SetupStore.prototype.setPayloadAction = function (type, tinyReducer) {
        return this.storeModule.setPayloadAction(type, tinyReducer);
    };
    SetupStore.prototype.build = function (newActions, newThunks) {
        var _this = this;
        if (newActions === void 0) { newActions = {}; }
        if (newThunks === void 0) { newThunks = {}; }
        var Context = this.storeModule.getContext();
        var useContext = this.storeModule.useContext(Context, newActions, newThunks);
        var Provider = function (_a) {
            var children = _a.children;
            return (React.createElement(Context.Provider, { value: _this.storeModule.getMemoValueHook()() }, children));
        };
        return { Provider: Provider, useContext: useContext };
    };
    return SetupStore;
}());
export { SetupStore };
//# sourceMappingURL=SetupStore.js.map